import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

import FIREBASE_API from '../firebase_config.json';

const firebaseApp = initializeApp(FIREBASE_API);
export const auth = getAuth(firebaseApp);
